import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { List, Map } from 'immutable';
import { Observable } from 'rxjs';
import { AuthHttpService } from '../auth-data/auth-http.service';
import { DocumentDataService } from '../document-data/document-data.service';
import { Schedule } from '../document-data/sub-models/schedule.model';
import { ITopLevelKeys } from '../entity-data/entity-data.data';
import { ErrorService } from '../error-reporting/error.service';
import { IResponseInfo } from '../http/http.data';
import { RendererService } from '../renderer/renderer.service';
import { GlobalSearch } from '../search-data/global-search.model';
import { SettingsDataStore } from '../settings-data/settings-data.store';
import { LoggerService } from '../shared/services/logger/logger.service';
import { InvoiceDataBuilder } from './invoice-data.builder';
import { map } from 'rxjs/operators';
import { IScheduleResponse } from './invoice-data.data';

@Injectable()
export class InvoiceDataService extends DocumentDataService {
  private _invoiceSchedulesUrl: string = '/schedules';

  topLevelKeys: ITopLevelKeys = {
    getKey: 'invoice_snippets',
    postKey: 'created_invoice',
    putKey: 'updated_invoice',
    deletedKey: 'deleted_invoices',
    deleteSingleKey: 'deleted_invoice',
    getSingleKey: 'invoice',
    searchResultsKey: 'invoice_results',
    globalSearchResultsKey: GlobalSearch.KEYS.INVOICES,
  };

  constructor(
    authHttpService: AuthHttpService,
    loggerService: LoggerService,
    errorService: ErrorService,
    rendererService: RendererService,
    invoiceDataBuilder: InvoiceDataBuilder,
    settingsDataStore: SettingsDataStore
  ) {
    super(
      '/invoices',
      authHttpService,
      invoiceDataBuilder,
      loggerService,
      rendererService,
      errorService,
      settingsDataStore
    );
  }

  // TODO: handle case where there are too many schedules and pagination gets triggered
  fetchSchedules(): Observable<IScheduleResponse> {
    return this.authHttpService.get(this._invoiceSchedulesUrl).pipe(
      map(({ body, ..._ }: IResponseInfo) => {
        return {
          schedules: List<any>(body['schedules'] || []).map(
            (value) => new Schedule(value)
          ) as List<Schedule>,
          deletedIds: List<string>(body['deleted_ids']),
        };
      })
    );
  }

  updateSchedule(
    documentId: string,
    payload: Map<string, any>
  ): Observable<Schedule> {
    return this.authHttpService
      .put(
        Location.joinWithSlash(this._invoiceSchedulesUrl, documentId),
        payload.toJS()
      )
      .pipe(
        map(
          ({ body, ..._ }: IResponseInfo) =>
            new Schedule(body['updated_schedule'])
        )
      );
  }

  deleteSchedule(documentId: string): Observable<IResponseInfo> {
    return this.authHttpService.delete(
      Location.joinWithSlash(this._invoiceSchedulesUrl, documentId)
    );
  }
}
